import { EnrollmentProfileWizard } from "@/components/enrollment/EnrollmentProfileWizard";
import { useAdeProfiles } from "@/hooks/useAdeProfiles";

export default function NewEnrollmentProfilePage() {
  const { createProfile } = useAdeProfiles();

  return <EnrollmentProfileWizard onSave={createProfile} />;
}
